import React, { useEffect, useState } from 'react';
import styles from './Share.module.sass';
import facebookIcon from '../../../../../../images/icons/share/facebook-share-button.svg';
import twitterIcon from '../../../../../../images/icons/share/twitter-share-button.svg';
import urlIcon from '../../../../../../images/icons/share/url-share-button.svg';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';

function Share() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) { return null; }

  const url = window.location.href;

  return (
    <div className={styles.share}>
      <div className={styles.title}>
        Share:
      </div>
      <div className={styles.icons}>
        <a href={`https://www.facebook.com/share.php?u=${url}`} className={styles.icon}>
          <img src={facebookIcon} alt="facebook" />
        </a>
        <a href={`https://www.twitter.com/share?url=${url}&text=I%20pre-ordered%20this%20product`} className={styles.icon}>
          <img src={twitterIcon} alt="twitter" />
        </a>
        { typeof window !== 'undefined' && window.navigator.share && (
          <ClickableDiv
            className={styles.icon}
            onClick={() => {
              window.navigator.share({
                url,
              }).then(() => {}).catch(() => {});
            }}
          >
            <img src={urlIcon} alt="url" />
          </ClickableDiv>
        )}
      </div>
    </div>
  );
}

export default Share;
